module.exports = __webpack_public_path__ + "statics/img/cate1-1@2x.d640bb00.png";